import Component from '../core/Component'
import { queryAll } from '../utils/dom'
import { getScrollTop } from '../services/Viewport/scroll'

export default class Hero extends Component {

    constructor(element) {
        super(element)

        this.handelScroll = ::this.handelScroll
        this.handleResize = ::this.handleResize
    }

    prepare() {
        this.items = queryAll('.hero-item', this.element)
            .map(element => ({
                element: element,
                ratio: parseFloat(element.getAttribute('data-parallax'))
            }))

        window.addEventListener('scroll', this.handelScroll, {
            passive: true
        })
        window.addEventListener('resize', this.handleResize)
        this.resize()
    }

    destroy() {
        window.removeEventListener('scroll', this.handelScroll, {
            passive: true
        })
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize(){
        this.resize()
    }

    resize(){
        this.height = this.element.offsetHeight + 200
    }

    handelScroll() {
        const offset = getScrollTop()
        if (offset < this.height){
            this.items.forEach(item => item.element.style.transform = `translateY(${offset * item.ratio}px)`)
        }
    }



}